/* RESPONSIBLE TEAM: team-proactive-support */
export default function (model) {
  return 'apps.app.outbound.message';
}
